import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import VueGtm from "vue-gtm";

// Plugins
// -> Alert 美化套件
import Swal from "sweetalert2";
// -> Lodash
import _ from "lodash";
// -> JQuery
import $ from "jquery";
// -> AXIOS
import axios from "axios";
// -> BootstrapVue
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// -> Input 美化套件
import Multiselect from "vue-multiselect";
// -> Lazy Load 懶加載
import VueLazyload from "vue-lazyload";
// -> 提示用美化小彈窗
import Snotify from "vue-snotify";
// -> LightBox
import Lightbox from "vue-easy-lightbox";
// -> Touch Event
import Vue2TouchEvents from "vue2-touch-events";

// Others
// -> 前台使用 axios
import frontendAxios from "./helpers/frontendAxiosConfig";
// -> 金錢 Format
import formatMoney from "./helpers/formatMoney";
// -> 檢查圖片是否存在
import { imageIsExist } from "./helpers/imgIsExist";
// -> 引入預設錯誤圖片
import defaultNotFoundImg from "./assets/images/404/404_img_not_found.png";
// -> 引入 Liff 設定檔
import { lineLiffInit } from "./helpers/lineLiffInit";
// -> 引入 Google Tag Manager 網站追蹤
import trackService from "./helpers/trackService";

// 設定全域變數 或 註冊全域指令
// -> 使全域吃的到 API 網址
Vue.prototype.$frontendAxios = frontendAxios;
Vue.prototype.$frontendApiUrl = process.env.VUE_APP_FUBON_FRONTEND_API_URL;
// -> 使全域吃得到 Sweetalert2
Vue.prototype.$Swal = Swal;
// -> 使全域吃得到 Loadsh
Vue.prototype.$_ = _;
// -> 使全域吃得到 JQuery
Vue.prototype.$ = $;
// -> 使全域吃得到 AXIOS
Vue.prototype.$axios = axios;
// -> 使全域吃得到 FormatMoney
Vue.prototype.$formatMoney = formatMoney;
// -> 使全域可以使用檢查圖片是否存在
Vue.directive("real-img", async function(el, binding) {
  let imgURL = binding.value; //获取图片地址
  let defaultURL = el.getAttribute("default-img"); //获取默认图片地址
  if (imgURL) {
    let exist = await imageIsExist(imgURL);
    if (exist) {
      el.setAttribute("src", imgURL);
    } else {
      // 如果使用 v-real-img 的 tag 上有 default-img 預設錯誤圖片就用, 沒有就用全域錯誤圖片
      if (defaultURL) {
        el.setAttribute("src", defaultURL);
      } else {
        el.setAttribute("src", defaultNotFoundImg);
      }
    }
  } else {
    // 如果使用 v-real-img 的 tag 上有 default-img 預設錯誤圖片就用, 沒有就用全域錯誤圖片
    if (defaultURL) {
      el.setAttribute("src", defaultURL);
    } else {
      el.setAttribute("src", defaultNotFoundImg);
    }
  }
});

//- 套件使用
// -> BootstrapVue, Install BootstrapVue
Vue.use(BootstrapVue);
// -> BootstrapVue, Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// -> Lazy Load 懶加載
Vue.use(VueLazyload, {
  preLoad: 1,
  error: require("./assets/images/404/404_img_not_found.png"),
  loading: require("./assets/images/loading/loading.gif"),
  attempt: 1,
});
// -> Input 美化套件
Vue.component("multiselect", Multiselect);
Vue.use(VueGtm, {
  // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  id: process.env.VUE_APP_GTM_ID,
  // Add url query string when load gtm.js with GTM ID (optional)
  // queryParams: {
  //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview:'env-4',
  //   gtm_cookies_win:'x'
  // },
  // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // enabled: process.env.NODE_ENV === 'development',
  // Whether or not display console logs debugs (optional)
  debug: process.env.NODE_ENV === "development",
  // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  loadScript: false,
  // Pass the router instance to automatically sync with router (optional)
  vueRouter: router,
  // If router, you can exclude some routes name (case insensitive) (optional)
  ignoredViews: ["404"],
});
// -> 提示用美化小彈窗
Vue.use(Snotify, {
  toast: {
    timeout: 2500,
    showProgressBar: false,
    pauseOnHover: false,
    animation: {
      enter: "fadeInRight",
      exit: "fadeOutRight",
      time: 500,
    },
  },
});
// -> LightBox
Vue.use(Lightbox);
// -> Touch Event
Vue.use(Vue2TouchEvents);

Vue.config.productionTip = false;

//- Liff 相關設定
// -> liff 本體
Vue.prototype.$liff = window.liff;
// -> 存放使用者的 uuid
Vue.prototype.$line_uuid = null;
// -> 存放使用者的 Line displayName
Vue.prototype.$line_user_displayName = null;

//- 其他設定
// -> 設定顯示 swal 初始值
window.showRequestLoadingSwal = true;
// -> 設定是不是第一次載入
var firstLoad = true;

// - 每頁切換時會檢查是否有 uuid, 沒有就導回登入頁面
router.beforeEach((to, from, next) => {
  //- 設置網頁的 Title
  var defaultTitle = "銀保服務站";
  //- 假如是第一次登入
  if (firstLoad) {
    //- 畫面改為載入中\
    if (!localStorage.getItem('from_url')) {
      localStorage.setItem('from_url', window.location.href)
    }
    store.commit("loadingHandler", true);
    lineLiffInit().then((result) => {
      if (result.pass) {
        //- 帶入使用者的 Line 資訊
        store.commit("setUserInfo", result.profileInfo);
        //- 帶入全域 Line Uuid
        Vue.prototype.$line_uuid = result.profileInfo
          ? result.profileInfo.userId
          : null;
        //- 直接打 login 拿新的 token
        frontendAxios
          .post(`${process.env.VUE_APP_FUBON_FRONTEND_API_URL}/login`, {
            line_uuid: Vue.prototype.$line_uuid,
          })
          .then((response) => {
            //- 檢查是否綁定
            window.localStorage.removeItem("token");
            localStorage.setItem(
              "token",
              response.data.data.access_token
                ? response.data.data.access_token
                : null
            );
            //- 判斷是否綁定了 綁定了就轉到首頁
            if (response.data.data.is_bind === true) {
              //- 關閉 Swal
              Swal.close();
              //- 導頁判斷是否在登入頁或綁定頁, 是就導頁

              let from_url = localStorage.getItem('from_url');
              let go_edit_page = from_url && from_url.indexOf('editMember') > -1;
              if (go_edit_page) {
                localStorage.removeItem('from_url');
                next({
                  name: `edit_member`,
                });
              } else if (
                (to.name === "login" || to.name === "sign_up" || to.name === "sign_up_pending") ||
                to.name === null ||
                to.name === "" ||
                to.name === undefined ||
                to.name === "404"
              ) {
                next({
                  path: "/index/home",
                });
              } else {
                next();
              }
            } else if (response.data.data.is_bind === false) {
              //- 關閉 Swal
              Swal.close();
              //- 導頁並判斷是否在 Login 頁面, 如果不是就導到 Login 頁面
              if (
                to.name !== "login" ||
                to.name === null ||
                to.name === "" ||
                to.name === undefined
              ) {
                next({
                  path: "/login",
                });
              } else {
                next();
              }
            } else {
              //- 其他都直接倒到 Login 頁面
              //- 關閉 Swal
              Swal.close();
              //- 導頁並判斷是否在登入頁, 如果不是就導到登入頁面
              if (
                to.name !== "login" ||
                to.name === null ||
                to.name === "" ||
                to.name === undefined
              ) {
                next({
                  path: "/login",
                });
              } else {
                next();
              }
            }
          })
          .catch((error) => {
            console.error("login失敗", error);
          })
          .then(() => {
            //- 把第一次載入改為 false;
            firstLoad = false;
            //- 畫面改為非載入中
            store.commit("loadingHandler", false);
          });
      } else {
        return;
      }
    });
  }
  // 檢查登入
  if (to.meta.requiresAuth && !firstLoad) {
    // 需要登入，且有 token
    if (window.localStorage.getItem("token") !== null) {
      // 改為 false 讓之後可以抓的到
      firstLoad = false;
      //- 檢查 router.js 有沒有設定網頁 title 如果沒有就用預設的
      document.title = to.meta.title ? to.meta.title : defaultTitle;
      // 由 store 檢查 token 是否存在，若 token 過期，仍讓其打 api 回傳 401 再轉導登出
      next();
    } else {
      // 第一次載入要 return 防止跳出彈跳警告視窗, App.js 驗證 token 及 導頁, 所以這邊不用做
      if (firstLoad) {
        // 改為 false 讓之後可以抓的到
        firstLoad = false;
        return;
      }
      // 需要登入，且無 token，轉至登入頁
      Swal.fire({
        title: "授權失敗，請重新登入[Error:Not Have Token]",
        icon: "info",
        showConfirmButton: true,
        heightAuto: false,
        allowOutsideClick: false,
      }).then((result) => {
        if (result.value) {
          next({ name: "login" });
        }
      });
    }
  }
});

//- 追蹤每個 router 切換後的事件
router.afterEach((route) => {
  // 時間稍微延遲以避免抓取到前個 window.location.href 位置
  setTimeout(() => {
    if (process.env.VUE_APP_GTM_ID && process.env.NODE_ENV === "production") {
      trackService.pageUserTrack({ line_uuid: Vue.prototype.$line_uuid });
    }
  }, 500);
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
